import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
`;

export const Wrapper = styled.div` 
    width: 100%;
    height: auto;
    padding-inline: 1rem;
    padding-block: 0 2rem;

    gap: 1.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    background-color: #FFFF;

    >div{
        width: 100%;
    }

    @media (max-width: 479px) {
        gap: 1rem;
    }
`;

export const MainContainers = styled.div`
    gap: 1.5rem;
    display: flex;
    justify-content: center;
    // PrimaryContainer (720px) + gap (24px) + SecondContainer (330px) = 1074px -
    // era 1028px, menor que a soma real das duas colunas, por isso ficava
    // desalinhado com farm-header/card-notification (ver Container em
    // components/nova-farm/farm-header/styles.js e card-notification/styles.js,
    // que precisam do mesmo valor).
    max-width: 1074px;

    @media (max-width: 1310px) {
        flex-direction: column;
        align-items: center;
    }

    @media (max-width: 760px) {
        gap: 1rem;
    }
`

export const PrimaryContainer = styled.div`
    width: 100%;
    // Encolhido de volta (era 51.375rem, largo demais pra 6 cards) agora que
    // a previsão diária mostra só 5 dias - sobrava espaço vazio depois do
    // último card. Estimado pela proporção do print, pode precisar de ajuste fino.
    max-width: 720px;

    gap: 1.5rem;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;

    /* >div>div>div>div {
        max-width: 21.125rem;
        max-height: 15.938rem;
    } */

    @media (max-width: 1310px) {
        width: 100%;

        align-items: center;
    }
`

export const MapView = styled.div`
    width: 100%;
    // "flex:1" - o SecondContainer fica esticado (altura da coluna da
    // esquerda, bem maior) pelo align-items:stretch padrão do flex-row do
    // MainContainers; o mapa absorve esse espaço sobrando entre o Caderno de
    // Campo (altura fixa) e as cotações logo abaixo, pra essas ficarem
    // alinhadas com o fim da coluna da esquerda em vez de deixar vão em branco.
    flex: 1;
    min-height: 354px;

    // No mobile as colunas empilham (MainContainers vira flex-direction:column
    // nessa largura) - não existe mais "coluna da esquerda" maior pra esticar
    // junto. Altura fixa de ~300px (igual ao mapa em pages/novo-produtores) -
    // o widget do meteoblue é conteúdo de terceiro, não estica o próprio
    // conteúdo pra preencher uma altura maior (ver mapView/styles.js); deixar
    // o container mais alto que isso só sobra área em branco dentro do iframe.
    @media (max-width: 1310px) {
        flex: none;
        height: 300px;
        min-height: 300px;
    }
`;

export const Background = styled.div`
    width: 100%;
    height: auto;
    padding: 4px;
    
    gap: 1rem;
    display: flex;
    flex-direction: column;
    border-radius: 0.75rem;
    background-color: ${theme.colors.gray.Cinza_13};

    @media (max-width: 1310px) {
        /* flex-direction: row; */
        width: 100%;
        max-width: 100%;
        align-items: center;
    }

    @media (max-width: 760px) {
        // "stretch" - no mobile, o GraphicPreview precisa ocupar a largura
        // toda, sem sobrar espaço em branco do lado.
        align-items: stretch;

        /* >div:nth-of-type(1) {
            height: 66rem;
        } */
    }
`;

export const GraphicsContainer = styled.div`
    width: 100%;
    height: auto;
    
    gap: 1rem;
    display: flex;

    @media (max-width: 1310px) {
        flex-wrap: wrap;
        
        >div:nth-of-type(1) {
            max-width: 100%;
        }
    }

    @media (max-width: 1024px) {

    }

    @media (max-width: 966px) {
        flex-direction: column;
        align-items: center;
    }

    @media (max-width: 375px) {
        width: 91%;
    }
`

export const SecondContainer = styled.div`
    width: 100%;
    // "auto" em vez de altura fixa - agora que o mapa do meteoblue (300px)
    // entrou nessa coluna junto do Caderno de Campo e das cotações, uma altura
    // fixa cortaria o conteúdo.
    height: auto;
    max-width: 330px;

    gap: 24px;
    display: flex;
    flex-direction: column;

    @media (max-width: 1310px) {
        max-width: 100%;
    }

    @media (max-width: 760px) {
        height: auto;

        gap: 1rem;
    }
`

export const ContainerFarmCropManagement = styled.div`
    width: 100%;
    // "auto" em vez de 100% - com align-items:stretch padrão do flex-row do
    // MainContainers, height:100% esticava esse container pra acompanhar a
    // altura (bem maior) da coluna da esquerda, deixando um vão enorme em
    // branco antes do mapa do meteoblue, que entra logo abaixo.
    height: auto;
`

export const ThirdyContainer = styled(SecondContainer)`
`

export const ContainerDolarAndQuotation = styled.div`
    width: 100%;
    height: auto;

    gap: 8px;
    display: flex;

    @media (max-width: 1050px) {
        flex-direction: column;
    }

    @media (max-width: 760px) {
        gap: 0.5rem;
        flex-direction: row;

        >div{
            width: 49%;
        }
    }
`